/** 剧本创作节点：DeepSeek 系统提示（与 NodeGraphCanvas.executeScriptWriteNode 一致） */
export const SCRIPT_WRITE_DEEPSEEK_SYSTEM_PROMPT = `你是资深影视编剧与故事策划。请结合「上游参考材料」与「用户创作要求」，撰写一版可直接交给分镜团队使用的中文剧本/文学剧本。

要求：
- 使用中文；场景标题与场次清晰（可用「场景一」「内/外·日/夜」等标注）；
- 对白、动作与情绪描写具体，节奏连贯，人物性格一致；
- 在保留用户核心创意与设定的前提下，可合理扩写、润色与补全情节；
- 若用户注明题材、集数、时长或风格，须严格遵守；
- 不要输出寒暄、前言或创作说明，直接给出剧本正文。`

/** 下拉选「自定义…」时的 value */
export const SCRIPT_WRITE_SELECT_CUSTOM = '__custom__'

export const SCRIPT_WRITE_GENRE_OPTIONS = [
  { id: '', label: '不限题材' },
  { id: '都市情感', label: '都市情感' },
  { id: '悬疑短剧', label: '悬疑短剧' },
  { id: '古装仙侠', label: '古装仙侠' },
  { id: '科幻冒险', label: '科幻冒险' },
  { id: '喜剧搞笑', label: '喜剧搞笑' },
  { id: '励志成长', label: '励志成长' },
  { id: '广告宣传片', label: '广告 / 宣传片' },
  { id: '品牌故事', label: '品牌故事' },
  { id: SCRIPT_WRITE_SELECT_CUSTOM, label: '自定义…' }
]

export const SCRIPT_WRITE_LENGTH_OPTIONS = [
  { id: '', label: '不限篇幅' },
  { id: '30 秒', label: '30 秒' },
  { id: '1 分钟', label: '1 分钟' },
  { id: '3 分钟', label: '3 分钟' },
  { id: '5 分钟', label: '5 分钟' },
  { id: '10 分钟', label: '10 分钟' },
  { id: '单集 3～5 分钟', label: '单集 3～5 分钟' },
  { id: '迷你剧 8～12 集', label: '迷你剧 8～12 集' },
  { id: SCRIPT_WRITE_SELECT_CUSTOM, label: '自定义…' }
]

function resolveScriptWritePick(d, pickField, customField, legacyField, options) {
  if (!d || typeof d !== 'object') return ''
  const pick = d[pickField] != null ? String(d[pickField]).trim() : ''
  if (pick === SCRIPT_WRITE_SELECT_CUSTOM) {
    return String(d[customField] || '').trim()
  }
  if (pick) {
    const hit = options.find(o => o.id === pick)
    return hit ? String(hit.label || hit.id).trim() : pick
  }
  return String(d[legacyField] || '').trim()
}

export function resolveScriptWriteGenre(d) {
  return resolveScriptWritePick(d, 'genrePick', 'genreCustom', 'genre', SCRIPT_WRITE_GENRE_OPTIONS)
}

export function resolveScriptWriteLengthHint(d) {
  return resolveScriptWritePick(
    d,
    'lengthHintPick',
    'lengthHintCustom',
    'lengthHint',
    SCRIPT_WRITE_LENGTH_OPTIONS
  )
}

export function exportScriptWriteNodeText(n) {
  if (!n || n.type !== 'scriptWrite') return ''
  const d = n.data || {}
  const refined = String(d.output || '').trim()
  const draft = String(d.body || '').trim()
  const main = refined || draft
  if (!main) return ''
  const genre = resolveScriptWriteGenre(d)
  const hint = resolveScriptWriteLengthHint(d)
  const meta = [genre && `题材：${genre}`, hint && `篇幅：${hint}`].filter(Boolean).join('；')
  if (meta) return `【剧本】${meta}\n${main}`
  return `【剧本】\n${main}`
}
